export default "__VITE_ASSET__Czx6fYV1__"